export const IS_REQUIRED = "This is a required field.";
export const SHOULD_BE_NUMBER = "Should be number.";
export const CHARACTER_MAX = "characters max.";
export const UNSAVED_CHANGES =
  "You have unsaved changes. Are you sure you want to leave?";
export const ERROR_ON_PAGE = "Please review errors below.";
export const LOANNUMBER_INUSE = "The Loan number is already in use";
export const TIMEOUT_MESSAGE =
  "You have been timed out due to inactivity. Please login again.";
